import "./index.scss";
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

/**
 * Component: ProductSpecial
 */
export function ProductSpecial() {
  console.log("ProductSpecial mounted.");

  /**
   * Content carousel (slider) with extensive options to control behaviour and appearance
   * @requires https://swiperjs.com/
   */

  new Swiper('.swiper-special', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 2,
    spaceBetween: 24,

    modules: [Pagination],
  
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },

    breakpoints: {
      840: {
        slidesPerView: 3
      },
      992: {
        slidesPerView: 4
      }
    }    
  });  
    
}